import { RouterView, type RouterOptions } from "vue-router";
import EntityAudits from "@/components/EntityAudits.vue";
import { EntityDocuments } from "@modernary/mui/components/document";
import { EntityNotes } from "@modernary/mui/components/note";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  permits: "Permit.Permits",
  list: "Permit.PermitList",
  new: "Permit.PermitNew",
  base: "Permit.PermitBase",
  view: "Permit.PermitView",
  numberUpdate: "Permit.PermitNumberUpdate",
  notes: "Permit.PermitNotes",
  noteEdit: "Permit.PermitNoteEdit",
  noteNew: "Permit.PermitNoteNew",
  documents: "Permit.PermitDocuments",
  documentEdit: "Permit.PermitDocumentEdit",
  documentNew: "Permit.PermitDocumentNew",
  financialAssurances: "Permit.PermitFinancialAssurances",
  financialAssuranceEdit: "Permit.PermitFinancialAssuranceEdit",
  financialAssuranceNew: "Permit.PermitFinancialAssuranceNew",
  disposalReports: "Permit.PermitDisposalReports",
  reports: "Permit.PermitReports",
  audit: "Permit.PermitAudit",
};

export { names as permitRouteNames };

const permitRoutes: RouterOptions["routes"] = [
  {
    path: "/permits",
    name: names.permits,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: { title: "Permits", lookupGroups: ["PermitType", "PermitStatus"] },
        component: () => import("@/views/permit/PermitList.vue"),
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/permit/PermitBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Permit View" },
            component: () => import("@/views/permit/PermitView.vue"),
          },
          {
            path: "edit",
            name: names.numberUpdate,
            meta: { title: "Update Permit Number", isForm: true },
            component: () => import("@/views/permit/PermitNumberUpdate.vue"),
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Permit Internal Notes" },
            component: {
              render: () => <EntityNotes idField="permitId" routeNamePrefix="Permit.PermitNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Edit Permit Internal Note", isForm: true },
            component: () => import("@/views/permit/PermitNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Create Permit Internal Note", isForm: true },
            component: () => import("@/views/permit/PermitNote.vue"),
          },
          {
            path: "documents",
            name: names.documents,
            meta: { title: "Permit Documents" },
            component: {
              render: () => <EntityDocuments idField="permitId" routeNamePrefix="Permit.PermitDocument" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentEdit,
            meta: { title: "Edit Permit Document", isForm: true },
            component: () => import("@/views/permit/PermitDocument.vue"),
          },
          {
            path: "documents/new",
            name: names.documentNew,
            meta: { title: "Create Permit Document", isForm: true },
            component: () => import("@/views/permit/PermitDocuments.vue"),
          },
          {
            path: "financialAssurances",
            name: names.financialAssurances,
            meta: { title: "Permit Financial Assurance" },
            component: () => import("@/views/permit/PermitFinancialAssurances.vue"),
          },
          {
            path: "financialAssurances/:financialAssuranceId(\\d+)",
            name: names.financialAssuranceEdit,
            meta: { title: "Edit Permit Financial Assurance", isForm: true },
            component: () => import("@/views/permit/PermitFinancialAssurance.vue"),
          },
          {
            path: "financialAssurances/new",
            name: names.financialAssuranceNew,
            meta: { title: "Create Permit Financial Assurance", isForm: true },
            component: () => import("@/views/permit/PermitFinancialAssurance.vue"),
          },
          {
            path: "reports",
            name: names.reports,
            meta: { title: "Permit Reports" },
            component: () => import("@/views/permit/ReportsChildList.vue"),
          },
          {
            path: "disposalReports",
            name: names.disposalReports,
            meta: { title: "Permit Disposal Reports" },
            component: () => import("@/views/permit/DisposalReportChildList.vue"),
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Permit Audit Activity" },
            component: {
              render: () => <EntityAudits entityName="Permit" />,
            },
          },
        ],
      },
    ],
  },
];
export default permitRoutes;
